import { HSLColor } from '@yola/yola-palette-generator';
import buildGradientModelByString from './build-gradient-model-by-string';
import parseHslaColorString from './parse-hsla-color-string';

const MAX_LIGHTNESS = 1;
const LIGHTNESS_SHIFT = 0.25;
const ALPHA = 1;

const buildGradientModelFromSolidColorCSSValue = (solidColorCSSValue) => {
  let parsedSolidColor;

  try {
    parsedSolidColor = parseHslaColorString(solidColorCSSValue);
  } catch (e) {
    return null;
  }

  // Try to lighten by 25%; if it would exceed bounds, darken by 25% instead.
  const nextLightness =
    parsedSolidColor.l + LIGHTNESS_SHIFT <= MAX_LIGHTNESS
      ? parsedSolidColor.l + LIGHTNESS_SHIFT
      : parsedSolidColor.l - LIGHTNESS_SHIFT;

  const solidColorStop = new HSLColor(
    parsedSolidColor.h,
    parsedSolidColor.s,
    parsedSolidColor.l,
    ALPHA
  ).toCSSValue();
  const generatedColorStop = new HSLColor(
    parsedSolidColor.h,
    parsedSolidColor.s,
    nextLightness,
    ALPHA
  ).toCSSValue();
  const gradientCSSValue = `linear-gradient(90deg, ${solidColorStop} 0%, ${generatedColorStop} 100%)`;

  return buildGradientModelByString(gradientCSSValue);
};

export default buildGradientModelFromSolidColorCSSValue;
